import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import logoutAndRedirect from "../../utils/logoutAndRedirect";
import { getAccessToken } from "../../utils/tokenStore";

const URL_API = process.env.URL_API;

export const fileUpload = createAsyncThunk(
  "file/upload",
  async (post_data: any, { rejectWithValue }) => {
    const url = `${URL_API}/file-system/upload`;

    let formData = new FormData();

    const uploadPath = post_data?.customPath || "quote-requests/uploads";
    formData.append("path", uploadPath);

    for (let i = 0; i < post_data?.files?.length; i++) {
      formData.append("files[]", post_data.files[i]);
    }

    try {
      const response = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${getAccessToken()}`,
        },
      });

      return response;
    } catch (error: any) {
      if (error.response && error.response?.status === 401) {
        logoutAndRedirect("/sign-in");
      }

      return rejectWithValue(
        error?.response?.data ||
          error?.message ||
          "An error occurred while uploading the file.",
      );
    }
  },
);
